import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe, Check } from 'lucide-react';
import { LANGUAGES } from '@/i18n';
import { goToLanguage } from '@/lib/locale';
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu';

/**
 * Selettore lingua compatto (IT / EN / ES) per le aree loggate (AppShell).
 * Usa i18n.changeLanguage: la traduzione globale del DOM reagisce al cambio.
 */
export const LanguageSwitcher = ({ className = '' }) => {
  const { i18n } = useTranslation();
  const current = LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0];
  const change = (code) => {
    goToLanguage(code);
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          data-testid="lang-switcher"
          aria-label="Cambia lingua"
          data-no-translate
          className={`inline-flex items-center gap-1.5 rounded-full border border-border px-2.5 py-1.5 text-sm font-medium text-foreground transition-colors hover:bg-accent ${className}`}
        >
          <Globe className="h-4 w-4" />
          <span>{current.short}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44" data-no-translate>
        <DropdownMenuLabel>Lingua</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => change(l.code)}
            data-testid={`lang-option-${l.code}`}
            className="flex items-center justify-between"
          >
            <span className="flex items-center gap-2"><span>{l.flag}</span>{l.label}</span>
            {l.code === current.code && <Check className="h-4 w-4 text-primary" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
